// src/pages/accounts-receivable-management-dashboard/services/receberApi.js
import { authenticatedFetch } from "../../../auth/auth";

const cleanBaseUrl = (u) => String(u || "").replace(/\/+$/, "");

const API_BASE = cleanBaseUrl(import.meta.env.VITE_API_BASE_URL || "");
if (!API_BASE) {
  // Não quebra build, mas fica explícito no console do browser
  // (ajuda quando esquecer de setar o .env no build)
  console.warn("[receberApi] VITE_API_BASE_URL não definido.");
}

export async function fetchReceber(query = {}) {
  const params = new URLSearchParams();

  const de = query?.de;
  const ate = query?.ate;
  const base = (query?.base || "ALL").toUpperCase();
  const situacao = (query?.situacao || "TODOS").toUpperCase();
  const q = query?.q || "";

  if (de) params.set("de", de);
  if (ate) params.set("ate", ate);

  params.set("base", base);
  params.set("situacao", situacao);

  if (q) params.set("q", q);

  // anti-cache (evita 304 atrapalhar quando você muda filtros/base)
  params.set("_ts", String(Date.now()));

  const url = `${API_BASE}/api/receber?${params.toString()}`;

  const resp = await authenticatedFetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Cache-Control": "no-store",
      Pragma: "no-cache",
    },
    cache: "no-store",
  });

  const contentType = resp.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  const body = isJson ? await resp.json().catch(() => null) : await resp.text().catch(() => null);

  if (!resp.ok) {
    const msg =
      (body && typeof body === "object" && (body.message || body.error)) ||
      (typeof body === "string" && body) ||
      `Falha ao buscar contas a receber (HTTP ${resp.status})`;

    const err = new Error(msg);
    err.statusCode = resp.status;
    err.body = body;
    err.url = url;
    throw err;
  }

  return body;
}
